/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ loaded: NonNullable<unknown>, total: NonNullable<unknown> }} Read_Along_Search_Chapter_ProgressInputs */

const en_read_along_search_chapter_progress = /** @type {(inputs: Read_Along_Search_Chapter_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.loaded}/${i?.total} ch.)`)
};

const es_read_along_search_chapter_progress = /** @type {(inputs: Read_Along_Search_Chapter_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.loaded}/${i?.total} cap.)`)
};

/**
* | output |
* | --- |
* | "({loaded}/{total} ch.)" |
*
* @param {Read_Along_Search_Chapter_ProgressInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_search_chapter_progress = /** @type {((inputs: Read_Along_Search_Chapter_ProgressInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Search_Chapter_ProgressInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_search_chapter_progress(inputs)
	return en_read_along_search_chapter_progress(inputs)
});